/* Novelys NFC — apparitions au defilement.

   Pourquoi ce fichier existe a part : une animation d'apparition peut cacher
   definitivement du contenu si elle rate son declenchement. C'est arrive ici :
   le titre et le prix de la fiche produit sont restes a opacity:0. Sur une
   boutique, c'est une vente perdue en silence.

   Trois garde-fous, dans cet ordre :
   1. `threshold: 0` — un seul pixel visible suffit. Avec un seuil en pourcentage,
      un element fin ou pas encore mis en page peut ne jamais l'atteindre.
   2. Un seul observateur, reutilise. `reveal()` peut donc etre rappele apres le
      chargement des images et des polices, quand la mise en page a bouge.
   3. Un filet : au chargement complet, puis 1,2 s plus tard, tout ce qui se
      trouve deja dans l'ecran ou au-dessus est revele de force. Rien de visible
      ne peut rester invisible. */
(function () {
  'use strict';
  if (window.__nvRevealReady) return;
  window.__nvRevealReady = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = null;

  function marque(el) {
    el.classList.add('is-in');
    if (io) io.unobserve(el);
  }

  function reveal() {
    var items = document.querySelectorAll('[data-nv-in]:not(.is-in)');
    if (!items.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) marque(e.target); });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
    }
    /* Observer deux fois le meme element ne coute rien : l'appel est ignore. */
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  /* Le filet. Tout element dont le haut est deja passe sous le bas de l'ecran
     est visible ou l'a ete : il n'a aucune raison de rester cache. */
  function filet() {
    var h = window.innerHeight || 800;
    document.querySelectorAll('[data-nv-in]:not(.is-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < h) marque(el);
    });
  }

  function boot() {
    reveal();
    filet();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  window.addEventListener('resize', reveal, { passive: true });
  document.addEventListener('shopify:section:load', boot);
  setTimeout(boot, 1200);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(boot).catch(function () {});

  window.nvReveal = reveal;
})();
